import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NOTIFICATIONS = [{
  name: 'Camila',
  city: 'Buenos Aires'
}, {
  name: 'Laura',
  city: 'Santiago'
}, {
  name: 'Valentina',
  city: 'Lima'
}, {
  name: 'Mariana',
  city: 'Medellín'
}, {
  name: 'Sofía',
  city: 'Montevideo'
}, {
  name: 'Daniela',
  city: 'Quito'
}, {
  name: 'Fernanda',
  city: 'Córdoba'
}, {
  name: 'Julieta',
  city: 'Bogotá'
}];
export function FloatingNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first notification
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 5 seconds
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimeout);
  }, [isVisible, currentIndex]);
  useEffect(() => {
    if (isVisible) return;
    // Show next notification after random delay between 25-40 seconds
    const nextDelay = Math.floor(Math.random() * (40000 - 25000 + 1) + 25000);
    const showTimeout = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % NOTIFICATIONS.length);
      setIsVisible(true);
    }, nextDelay);
    return () => clearTimeout(showTimeout);
  }, [isVisible]);
  const currentNotification = NOTIFICATIONS[currentIndex];
  if (!currentNotification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-700 ease-in-out transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-10">
      <div className="bg-white rounded-full shadow-lg py-3 px-5 flex items-center gap-3 border border-gray-100 max-w-xs sm:max-w-sm" data-id="element-11">
        <div className="bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-12">
          <CheckCircle2 className="w-4 h-4 text-[#5F8F6F]" data-id="element-13" />
        </div>
        <p className="text-sm text-gray-700 font-medium leading-tight" data-id="element-14">
          <span className="font-bold text-gray-900" data-id="element-15">
            {currentNotification.name}
          </span>{' '}
          de {currentNotification.city} accedió al programa hace unos minutos
        </p>
      </div>
    </div>;
}